import React, { Component } from 'react';

import { trans, getResourcePath, SoyuzFlag } from '@spotahome/soyuz/client';

import { Button } from '@spotahome/ui-library';

import { sendContactUsForm } from '../../common/api/real-estate-client';

// Components
import HeaderContainer from '../../common/components/HeaderContainer';
import SectionHeading from '../../common/components/SectionHeading';
import Footer from '../../common/components/Footer';
import Hero from '../../common/components/Hero';
import Cookies from '../../common/components/Cookies';
import SessionExpiredModal from '../../common/components/SessionExpiredModal';

// 🚨 LEGACY
import Routing from '../../common/javascripts/cornucopia/core/routing';
import ContactInformationService from '../../common/javascripts/cornucopia/contact-us/contact-information-service';
import CUForm from '../../common/javascripts/contact-us/components/cu-form';
import AppBanner from '../../common/components/AppBanner';

import ContactUsRevamp from './components/ContactUsRevamp';

// Styles
import './../../common/scss/init.scss';
import './main.scss';

class ContactUsContainer extends Component {
  static NAME = 'ContactUsName';

  constructor(props, context) {
    super(props, context);

    this.state = {
      userType: '',
      userCountry: '',
      requesterName: '',
      requesterEmail: '',
      subject: '',
      message: '',
      formStatus: ''
    };
  }

  handleUserTypeChange = userTypeValue => {
    this.setState({
      userType: userTypeValue,
      userCountry: ''
    });
  };

  handleUserCountryChange = userCountryValue => {
    this.setState({
      userCountry: userCountryValue
    });
  };

  handleUpdateStateField = (key, value) => {
    const obj = {};
    obj[key] = value;
    this.setState(obj);
  };

  onFormSuccess = () => {
    this.setState({
      formStatus: 'success'
    });
  };

  onFormError = () => {
    this.setState({
      formStatus: 'error'
    });
  };

  handleSubmitForm = () => {
    const payload = {
      requesterName: this.state.requesterName,
      requesterEmail: this.state.requesterEmail,
      subject: this.state.subject,
      message: this.state.message,
      tags: {
        country: ContactInformationService.getCountryByCity(
          this.state.userCountry
        ),
        city: this.state.userCountry,
        contact_us: this.state.userType
      }
    };

    sendContactUsForm(payload).then(this.onFormSuccess).catch(this.onFormError);
  };

  render() {
    return (
      <SoyuzFlag name="ContactUsForm">
        {flag =>
          flag.isOff() ? (
            <div>
              <Hero
                menu={<HeaderContainer />}
                backgroundImage={`url(${getResourcePath(
                  '/images/contact-us/background-header.png'
                )})`}
              >
                <div className="hero__content-box">
                  <Hero.Title>{trans('contact_us.title')}</Hero.Title>
                  <Hero.SubTitle>{trans('contact_us.subtitle')}</Hero.SubTitle>
                  <Button
                    size="big"
                    alt
                    href={Routing.getUrlWithLocale(
                      'http://help.spotahome.com/hc'
                    )}
                    className="contact-us-hero__action"
                  >
                    {trans('contact_us.action')}
                  </Button>
                </div>
              </Hero>

              <section className="grid__wrapper">
                <div className="grid__wrapper--inner">
                  <div className="contact-us__heading">
                    <SectionHeading text={trans('contact_us.contact')} />
                    <p className="contact-us__claim">
                      {trans('contact_us.claim')}
                    </p>
                  </div>
                </div>
              </section>

              <CUForm
                userType={this.state.userType}
                userCountry={this.state.userCountry}
                requesterName={this.state.requesterName}
                requesterEmail={this.state.requesterEmail}
                subject={this.state.subject}
                message={this.state.message}
                formStatus={this.state.formStatus}
                onFieldChange={this.handleUpdateStateField}
                onUserTypeChange={this.handleUserTypeChange}
                onUserCountryChange={this.handleUserCountryChange}
                onSubmitForm={this.handleSubmitForm}
              />

              <Footer />
              <SessionExpiredModal />
              <Cookies />
              <AppBanner />
            </div>
          ) : (
            <ContactUsRevamp />
          )
        }
      </SoyuzFlag>
    );
  }
}

export default ContactUsContainer;
